/**
 * Types
 */

export const Types = {
  SET_COUPON_DATA: 'coupon/SET_COUPON_DATA'
};
